module.exports = __webpack_public_path__ + "img/g矩形 80@1x.7cf31e4b.png";